/**
 * Interface for notification requests that target users by id.
 */
export interface IRequestById {
    /**
     * Gets or sets the recipients.
     */
    recipients: Array<number>;

    /**
     * Validates the request.
     */
    validate(): void;
}
